<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="110px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="短信套餐名称">
                  <el-input style="width: 177px" v-model="queryForm.packageName"></el-input>
              </el-form-item>
              <el-form-item label="短信类型">
<!--                  <el-input  v-model="queryForm.smsType"></el-input>-->
                  <el-select clearable style="width: 177px" v-model="queryForm.smsType" placeholder="请选择" size="small">
                      <el-option label="接口短信" :value="0"></el-option>
                      <el-option label="广告短信" :value="1"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiSmsPackageList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiSmsPackage"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiSmsPackage(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiSmsPackage(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiSmsPackageList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiSmsPackageList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="packageName"
        label="短信套餐名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsCount"
        label="套餐短信条数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsType"
        label="短信类型"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.smsType == 0 ? '接口短信' : '广告短信'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="packagePic"
        label="短信套餐图片"
        width="180"
      >
          <template scope="scope">
              <el-image
                  @click='updateSrcList(scope.row.packagePic)'
                  style='width: 80px; height: 80px'
                  :src='scope.row.packagePic'
                  :preview-src-list='srcList'
              ></el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="packageMark"
        label="短信套餐备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="packagePrice"
        label="套餐价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="addTimeFormatter"
        label="短信套餐添加日期"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiSmsPackage(scop.row.packageId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiSmsPackage(scop.row.packageId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiSmsPackage(scop.row.packageId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiSmsPackageStates[apiSmsPackageState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiSmsPackage"
          ref="apiSmsPackageForm"
          :rules="rules"
          label-width="110px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="短信套餐名称"
            prop="packageName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="apiSmsPackage.packageName"
              :disabled="apiSmsPackageState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="套餐短信条数"
            prop="smsCount"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="apiSmsPackage.smsCount"
              :disabled="apiSmsPackageState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="短信类型"
            prop="smsType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsPackage.smsType"-->
<!--              :disabled="apiSmsPackageState == 'check'"-->
<!--            ></el-input>-->
              <el-select :disabled="apiSmsPackageState == 'check'" clearable style="width: 177px" v-model="apiSmsPackage.smsType" placeholder="请选择" size="small">
                  <el-option label="接口短信" :value="0"></el-option>
                  <el-option label="广告短信" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="短信套餐图片"
            prop="packagePic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsPackage.packagePic"-->
<!--              :disabled="apiSmsPackageState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="apiSmsPackage.packagePic" size="small" :disabled="apiSmsPackageState == 'check'"></el-input>
                  <el-button type="primary" :disabled="apiSmsPackageState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                      <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadAvatar">
                          <el-button type="primary" size="small" class="as">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="短信套餐备注"
            prop="packageMark"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="apiSmsPackage.packageMark"
              :disabled="apiSmsPackageState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="套餐价格"
            prop="packagePrice"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="apiSmsPackage.packagePrice"
              :disabled="apiSmsPackageState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiSmsPackageState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiSmsPackageList();
                    this.getApiSmsPackageList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiSmsPackageList();
                    this.getApiSmsPackageList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     packageName: '', //短信套餐名称
                     smsCount: '', //套餐内短信条数
                     smsType: '', //短信类型：0为接口短信; 1为广告短信
                     packagePic: '', //短信套餐展示图片
                     packageMark: '', //短信套餐备注
                     packagePrice: '', //套餐价格
                     addTime: '', //短信套餐添加日期
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiSmsPackageState: 'add',
                apiSmsPackageStates: {
                    add: '新建短信套餐',
                    check: '查看短信套餐',
                    edit: '修改短信套餐'
                },

                multipleSelection: [],
                apiSmsPackageList: [],
                apiSmsPackage: {
                    packageName: '', //短信套餐名称
                    smsCount: '', //套餐内短信条数
                    smsType: 0, //短信类型：0为接口短信; 1为广告短信
                    packagePic: '', //短信套餐展示图片
                    packageMark: '', //短信套餐备注
                    packagePrice: '', //套餐价格
                    addTime: '', //短信套餐添加日期
                },
                btnLoading: false,
                srcList: [''],
                rules: {
                    packageName: [{ required: true, message: '短信套餐名称不能为空', trigger: 'blur' }],
                    smsCount: [{ required: true, message: '套餐内短信条数不能为空', trigger: 'blur' }],
                    smsType: [{ required: true, message: '短信类型不能为空', trigger: 'blur' }],
                    packagePic: [{ required: true, message: '短信套餐展示图片不能为空', trigger: 'blur' }],
                    packageMark: [{ required: true, message: '短信套餐备注不能为空', trigger: 'blur' }],
                    packagePrice: [{ required: true, message: '套餐价格不能为空', trigger: 'blur' }],
                    addTime: [{ required: true, message: '短信套餐添加日期不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getApiSmsPackageList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.apiSmsPackage.packagePic = res.url;
                    }
                });
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            resetApiSmsPackageList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiSmsPackageList = [];
            },
            resetDialog() {
                this.apiSmsPackageState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      packageName: '', //短信套餐名称
                      smsCount: '', //套餐内短信条数
                      smsType: '', //短信类型：0为接口短信; 1为广告短信
                      packagePic: '', //短信套餐展示图片
                      packageMark: '', //短信套餐备注
                      packagePrice: '', //套餐价格
                      addTime: '', //短信套餐添加日期
                };
                this.getApiSmsPackageList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiSmsPackage = {
                      packageName: '', //短信套餐名称
                      smsCount: '', //套餐内短信条数
                      smsType: 0, //短信类型：0为接口短信; 1为广告短信
                      packagePic: '', //短信套餐展示图片
                      packageMark: '', //短信套餐备注
                      packagePrice: '', //套餐价格
                      addTime: '', //短信套餐添加日期
                };
            },
            submitForm() {
                if (this.apiSmsPackageState == 'add') {
                    this.$refs.apiSmsPackageForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smspackage/add`,{ ...this.apiSmsPackage }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiSmsPackageList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiSmsPackageState == 'edit') {
                    this.$refs.apiSmsPackageForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smspackage/edit`,{ ...this.apiSmsPackage }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiSmsPackageList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiSmsPackage() {
                this.showDialog = true;
                this.apiSmsPackageState = 'add';
            },
            checkApiSmsPackage(apiSmsPackageId) {
                console.log(apiSmsPackageId);
                this.currentApiSmsPackageId = apiSmsPackageId;

                this.getApiSmsPackageById();
                this.showDialog = true;
                this.apiSmsPackageState = 'check';
            },
            editApiSmsPackage(apiSmsPackageId) {
                console.log('apiSmsPackage', apiSmsPackageId);
                if (apiSmsPackageId) {
                    this.currentApiSmsPackageId = apiSmsPackageId;
                    this.getApiSmsPackageById();
                } else {
                    this.apiSmsPackage = { ...this.apiSmsPackage, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiSmsPackageState = 'edit';
            },
            deleteApiSmsPackage(apiSmsPackageId) {
                let ids = '';
                if (apiSmsPackageId) {
                    ids = apiSmsPackageId;
                } else {
                    ids = this.multipleSelection.map((apiSmsPackage) => apiSmsPackage.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/api/smspackage/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiSmsPackageList();
                                this.getApiSmsPackageList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiSmsPackageList() {
                this.resetApiSmsPackageList();
                this.getApiSmsPackageList();
            },
            getApiSmsPackageList(query = {}) {
                this.loading = true;
                get(`/api/smspackage/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiSmsPackageList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiSmsPackageById() {
                get(`/api/smspackage/get`,{ id: this.currentApiSmsPackageId }).then((res) =>{
                    if(res.success){
                      this.apiSmsPackage = { ...this.apiSmsPackage, ...res.apiSmsPackage };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiSmsPackageList() {
                //this.btnLoading = true;
                exprotExcel(`/api/smspackage/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/api/smspackage/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/api/smspackage/importData`,formData);
              this.refreshApiSmsPackageList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiSmsPackageList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiSmsPackageList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>